import { render } from "./AudioPlayer.vue?vue&type=template&id=44339a27"
import script from "./AudioPlayer.vue?vue&type=script&lang=js"
export * from "./AudioPlayer.vue?vue&type=script&lang=js"

import "./AudioPlayer.vue?vue&type=style&index=0&id=44339a27&lang=css"

import exportComponent from "C:\\Users\\weil\\Desktop\\bimbot\\repo\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__